import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNodemonComponent } from './simple-icons-nodemon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNodemonComponent ],
    exports:      [ SimpleIconsNodemonComponent ],
    bootstrap:    []
})
export class SimpleIconsNodemonModule {}
